import { Grid, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import OrderCart from "./OrderCart";
import { useDispatch, useSelector } from "react-redux";
import { getUserOrders } from "../../State/Order/Action";
import Loader from "../Loader/Loader";
import FilterListIcon from "@mui/icons-material/FilterList";

// Step 1: Filter Labels
const orderStatusOptions = [
  { label: "On The Way", value: "ON_THE_WAY" },
  { label: "Delivered", value: "DELIVERED" },
  { label: "Cancelled", value: "CANCELLED" },
  { label: "Returned", value: "RETURNED" },
];

// Step 2: Backend to Frontend Status Map
const statusMap = {
  SHIPPED: "ON_THE_WAY",
  DELIVERED: "DELIVERED",
  CANCELLED: "CANCELLED",
  RETURNED: "RETURNED",
};

const Order = () => {
  const dispatch = useDispatch();
  const { order } = useSelector((store) => store);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");

  useEffect(() => {
    dispatch(getUserOrders());
  }, [dispatch]);

  // Handle checkbox change
  const handleStatusChange = (statusValue) => {
    setSelectedStatuses((prev) =>
      prev.includes(statusValue)
        ? prev.filter((val) => val !== statusValue)
        : [...prev, statusValue]
    );
  };

  const renderFilters = () => (
    <div className="shadow-lg bg-white p-5 rounded-md w-full">
      <h1 className="font-bold text-lg">Filters</h1>
      <div className="space-y-4 mt-6">
        <h2 className="font-semibold text-sm text-gray-700">ORDER STATUS</h2>
        {orderStatusOptions.map((option) => (
          <div className="flex items-center" key={option.value}>
            <input
              type="checkbox"
              value={option.value}
              id={option.value}
              className="h-4 w-4 border-gray-300 text-red-600 focus:ring-red-500"
              checked={selectedStatuses.includes(option.value)}
              onChange={() => handleStatusChange(option.value)}
            />
            <label htmlFor={option.value} className="ml-3 text-sm text-gray-600">
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );

  // Filter orders based on selected statuses
  const filteredOrders = order?.orders?.response?.filter((item) => {
    const mappedStatus = statusMap[item?.orderStatus?.toUpperCase()];
    return selectedStatuses.length === 0 || selectedStatuses.includes(mappedStatus);
  });

  return order?.loading ? (
    <Loader />
  ) : order?.orders?.response?.length > 0 ? (
    <div className="min-h-screen flex flex-col mb-4">
      <main className="flex-1 overflow-y-auto">
        <div className="px-4 sm:px-6 lg:px-16 mt-8">
          <h1 className="text-2xl font-bold">My Orders</h1>
          <p className="text-sm text-gray-500 mt-1">
            {filteredOrders?.length} {filteredOrders?.length === 1 ? "order" : "orders"} found
          </p>
        </div>

        <div className="px-4 sm:px-6 lg:px-16 mt-8">
          {/* Mobile Filter Toggle */}
          {isMobile && (
            <div className="mb-4 flex justify-end">
              <button
                onClick={() => setShowFilter((prev) => !prev)}
                className="flex items-center px-4 py-2 text-sm font-semibold text-white bg-indigo-600 rounded-md hover:bg-indigo-500"
              >
                <FilterListIcon className="mr-2" /> {showFilter ? "Hide Filters" : "Show Filters"}
              </button>
            </div>
          )}

          <Grid container spacing={4}>
            {/* Filters */}
            {!isMobile || showFilter ? (
              <Grid item xs={12} md={3}>
                <div className="sticky top-5">{renderFilters()}</div>
              </Grid>
            ) : null}

            {/* Orders List */}
            <Grid item xs={12} md={9}>
              <div className="space-y-5">
                {filteredOrders?.map((item) => (
                  <OrderCart key={item.id} item={item} />
                ))}
              </div>
            </Grid>
          </Grid>
        </div>
      </main>
    </div>
  ) : (
    <div className="flex flex-col items-center justify-center min-h-[50vh] text-center">
      <img
        src="https://cdni.iconscout.com/illustration/premium/thumb/no-orders-5307074-4445701.png"
        alt="No Orders"
        className="w-52 mb-4"
      />
      <h3 className="text-xl font-semibold text-gray-700">You have no orders yet.</h3>
      <p className="text-sm text-gray-500 mt-1">Start shopping to see your orders here!</p>
    </div>
  );
};

export default Order;
